window.location.replace("taskpane.html" + window.location.search + window.location.hash);